import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

const InfoIcon = (props: SVGProps<any>): ReactElement => {
  return (
    <BaseIcon {...props}>
      <path d="M12.75 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
      <path d="M12 11.25h.75v5.25h.75" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
      <path d="M12.563 8.625a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" fill="currentColor"/>
    </BaseIcon>
  )
}
export default InfoIcon;